import mqttHandle from "@/utils/mqtt";

const mqtt = {
  namespaced: true,
  state: {
    mqttClient:null,
    changeDeviceStatus:null,
    changeDeviceProp:null,
  },

  mutations: {
    SET_DEVICE_STATUS:(state,deviceProperty)=>{
      state.changeDeviceStatus=deviceProperty;
    },
    SET_DEVICE_PROP:(state,deviceProperty)=>{
      state.changeDeviceProp=deviceProperty;
    },
    SET_MQTT_CLIENT:(state,mqtt)=>{
      state.mqttClient=mqtt;
    },
  },

  actions: {
   //创建链接，接收数据
   sendTopics({state,commit,dispatch,rootState}){
     
    let {userId,deviceId} = window.miniImsp;
    let client,//mqtt 处理对象（全局变量）
      clientId=userId+"|"+"panelapp"+"|timestamp="+new Date().getTime(),
      topicSends=`sys/sz/device:${deviceId}/system/notification`;
      client = new mqttHandle(topicSends,clientId);
      client = client.createConnect();
      commit('SET_MQTT_CLIENT',client);
      dispatch('mqttOnmessage');

   },
   mqttOnmessage({state,commit,dispatch,rootState}){
     state.mqttClient.on("message", (topic, message) => {
        	try {

          let receiveNews='';
              receiveNews = receiveNews.concat(message);
              console.log('收到来自', topic, '的信息', message);
              console.log(JSON.parse(receiveNews));
			  //显隐式分类
			  dispatch("saveMsgByImplicit",JSON.parse(receiveNews))

        	} catch (error) {

          }
        });
   },
   saveMsgByImplicit({state,commit,dispatch,rootState},msg){
	   //根据消息结构区分不同的展示
	   switch(msg.properties.implicit){
	    case '0'://显式消息
          dispatch('messageLevelMap',msg)
	        break;
	    case '1'://隐式消息
		//数据分类
          dispatch('saveMsgByType',msg);
	        break;
		default:
			console.log(msg)
	   }
   },
   saveMsgByType({state,commit,dispatch,rootState},msg){
     let msgBody=JSON.parse(msg.body||"{}");
     console.log('隐式消息',msgBody)
     //根据消息产生的类型区分不同的存储
     switch(msg.properties.type){
       case 'devStatusNotification'://设备状态变化通知
          commit('SET_DEVICE_STATUS',msgBody);
            break;
       case 'devPropChangedNotification'://设备属性变化通知
          commit('SET_DEVICE_PROP',msgBody);
            break;
       default:
        console.log(msg)
     }
   },
   messageLevelMap({state,commit,dispatch,rootState},msg){
     let msgBody=JSON.parse(msg.body||"{}");
     console.log('显式消息',msgBody)
     switch(msg.properties.level){
        case 1:
          if(msg.properties.msgContentType=="text"&&msgBody.content){
            Message({message: msg.content,showClose: true,customClass:'custom-same-top-msg'})
          }
          break;
        case 2:
          if(msgBody.contentType=="text"&&msgBody.content){
            Message({message: msgBody.content,showClose: true,customClass:'custom-same-top-msg'})
          }
          break;
        case 3:
          if(msgBody.contentType=="text"&&msgBody.content){
            Message({message: msgBody.content,showClose: true,customClass:'custom-same-top-msg'})
          }
          break;
        default:
          if(msgBody.contentType=="text"&&msgBody.content){
            Message({message: msgBody.content,showClose: true,customClass:'custom-same-top-msg'})
          }
     }
   },
   closeClient({state,commit,dispatch,rootState}){
     state.mqttClient.end()
   }
  }
}

export default mqtt
